import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "./tools.css";

import one from "../../assets/pythonimages/tools/html.svg";
import two from "../../assets/pythonimages/tools/boo.png";
import three from "../../assets/pythonimages/tools/css.png";
import four from "../../assets/pythonimages/tools/djangopng.png";
import five from "../../assets/pythonimages/tools/flask.png";
import six from "../../assets/pythonimages/tools/javascript.png";
import seven from "../../assets/pythonimages/tools/mysql.png";
import eight from "../../assets/pythonimages/tools/postman.png";
import nine from "../../assets/pythonimages/tools/postsql.png";
import ten from "../../assets/pythonimages/tools/py.png";
import elven from "../../assets/pythonimages/tools/python.png";
// import twele from "../../assets/pythonimages/tools/testtn.png";


const clients = [
  { src: one, alt: "Apache JMeter" },
  { src: two, alt: "Appium" },
  { src: three, alt: "Appium JPG" },
  { src: four, alt: "Cucumber" },
  { src: five, alt: "Java" },
  { src: six, alt: "Jenkins" },
  { src: seven, alt: "JUnit" },
  { src: eight, alt: "LoadRunner" },
  { src: nine, alt: "Postman" },
  { src: ten, alt: "Selenium" },
  { src: elven, alt: "SoapUI" },
  // { src: twele, alt: "TestNG" },
];

function Tools() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <>
      <section style={{ marginTop: "50px" }}>
        <div className="headlines-for-all">
          <h4 data-aos="fade-up" >
            <span>Tools </span> Covered
          </h4>
          <p data-aos="fade-up">
            Gain hands-on experience with the most in-demand Python tools, frameworks, and programming concepts used by developers and data professionals.
          </p> </div>
      </section>

      <section className="our-clients-section">
        <div className="our-clients-container">
          <motion.div
            className="our-clients-track"
            animate={{ x: ["0%", "-100%"] }}
            transition={{
              ease: "linear",
              duration: 100,
              repeat: Infinity,
            }}
          >
            {[...clients, ...clients].map((client, i) => (
              <div
                className="client-item"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 150} // DELAY ONE-BY-ONE
              >
                <img src={client.src} alt={client.alt} />
              </div>
            ))}
          </motion.div>
        </div>
      </section>
    </>
  );
}

export default Tools;
